import { Stack, Typography } from "@mui/material";
import { FormikTextField } from "@shared";
import { ClientPersonalDataMaxLength } from "@shared";
import { FormikProps } from "formik";

import { EditClientType } from "@/pages/clients/client/components/tabs/master-data-tab/views/personal-data/EditClient.types";
import { useTranslation } from "@/translations";

interface Props {
  formik: FormikProps<EditClientType>;
}

export function PersonalDataCommentSection({ formik }: Props) {
  const { t } = useTranslation();

  return (
    <Stack gap={3}>
      <Typography variant="h5">{t("clients.client.masterData.personalData.label")}</Typography>
      <FormikTextField
        formik={formik}
        fieldName="comment"
        label={t("clients.create.comment")}
        multiline
        rows={3}
        slotProps={{ input: { inputProps: { maxLength: ClientPersonalDataMaxLength.comment } } }}
      />
    </Stack>
  );
}
